/**
 * Controle de acesso do Painel Master.
 * A verificação acontece sempre no backend; o frontend usa a mesma tabela
 * apenas para esconder ações que o usuário não pode executar.
 */
export const ROLES = ['owner', 'admin', 'operator', 'analyst'] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  owner: 'Proprietário',
  admin: 'Administrador',
  operator: 'Operador',
  analyst: 'Analista',
};

export const PERMISSIONS = [
  'providers.read',
  'providers.write',
  'instances.read',
  'instances.write',
  'instances.operate',
  'instances.rotate_token',
  'agents.read',
  'agents.write',
  'agents.publish',
  'integrations.read',
  'integrations.write',
  'usage.read',
  'usage.budget',
  'audit.read',
  'users.read',
  'users.write',
  'alerts.ack',
] as const;
export type Permission = (typeof PERMISSIONS)[number];

const READ: Permission[] = [
  'providers.read',
  'instances.read',
  'agents.read',
  'integrations.read',
  'usage.read',
];

export const ROLE_PERMISSIONS: Record<Role, readonly Permission[]> = {
  owner: PERMISSIONS,
  admin: PERMISSIONS.filter((p) => p !== 'users.write'),
  operator: [...READ, 'instances.operate', 'alerts.ack', 'audit.read'],
  analyst: [...READ],
};

/** Papéis que exigem MFA ativo para usar o painel. */
export const MFA_REQUIRED_ROLES: readonly Role[] = ['owner', 'admin'];

export function can(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
